// extracted by mini-css-extract-plugin
module.exports = {"box":"idealist_box__Gu47q","ideas":"idealist_ideas__UhTS9","ideaTitle":"idealist_ideaTitle__sUDeC"};